const Toggle = ({ checked, onChange, ...props }: React.InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <div className="relative flex flex-col items-center justify-center overflow-hidden">
      <label className="relative inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          onChange={onChange}
          readOnly
          {...props}
        />
        <div className="peer h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-green-600 peer-focus:ring-green-300 after:absolute after:top-0.5 after:left-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
      </label>
    </div>
  );
};
export default Toggle;
